import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { SearchAutocompleteResponse } from '../../responses/platform/search-autocomplete.response';
import { KitDetailsResponse } from '../../responses/platform/kit-details.response';
import { KitDetailsCorreiosEstimateResponse } from '../../responses/platform/kit-details-correios-estimate.response';

@Injectable({
  providedIn: 'root',
})
export class KitDetailsService extends CommonService {
  constructor(
    private router: Router,
    private httpClient: HttpClient
  ) {
    super();
  }

  public get(idKit: number, zipcode:string|null): Observable<KitDetailsResponse> {
    let url:string = environment.urlApiPlatform + 'KitDetails/idKit/' + idKit;
    if(zipcode)
      url += '?zipcode=' + zipcode
    return this.httpClient
      .get<KitDetailsResponse>(url, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public getCorreios(idKit: number, zipcode:string): Observable<KitDetailsCorreiosEstimateResponse> {
    let url:string = environment.urlApiPlatform + `KitDetails/idKit/${idKit}/zipcode/${zipcode}` ;
   
    return this.httpClient
      .get<KitDetailsCorreiosEstimateResponse>(url,this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
